var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home-container"},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view')],1),_c('ReminderDialog2',{ref:"reminderDialog2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }